module.exports = __webpack_public_path__ + "img/instagram.9bec02f9.svg";